// Translations for the Contributions page.
const contributionsDict = [
  { en: "Process payroll deductions for this month?", sw: "Chakata makato ya mshahara kwa mwezi huu?" },
  { en: "Import", sw: "Ingiza" },
  { en: "records?", sw: "rekodi?" },
  { en: "Import failed", sw: "Uingizaji umeshindwa" },
  { en: "Contributions", sw: "Michango" },
  { en: "Manage member contributions", sw: "Simamia michango ya wanachama" },
  { en: "Import CSV", sw: "Ingiza CSV" },
  { en: "Process Payroll", sw: "Chakata Mshahara" },
  { en: "Month:", sw: "Mwezi:" },
  { en: "Year:", sw: "Mwaka:" },
  { en: "Total Months", sw: "Jumla ya Miezi" },
  { en: "Paid Months", sw: "Miezi Iliyolipwa" },
  { en: "Total Paid", sw: "Jumla Iliyolipwa" },
  { en: "Total Collected", sw: "Jumla Iliyokusanywa" },
  { en: "Completed", sw: "Imekamilika" },
  { en: "Pending", sw: "Inasubiri" },
  { en: "CSV Preview", sw: "Muhtasari wa CSV" },
  { en: "records", sw: "rekodi" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Confirm Import", sw: "Thibitisha Kuingiza" },
  { en: "Member #", sw: "Namba ya Mwanachama" },
  { en: "Amount", sw: "Kiasi" },
  { en: "Period Month", sw: "Mwezi wa Kipindi" },
  { en: "Period Year", sw: "Mwaka wa Kipindi" },
  { en: "...and", sw: "...na" },
  { en: "more", sw: "zaidi" },
  { en: "My Contributions", sw: "Michango Yangu" },
  { en: "Contributions for", sw: "Michango ya" },
  { en: "No Contributions Found", sw: "Hakuna Michango Iliyopatikana" },
  { en: "No contribution records for this period", sw: "Hakuna rekodi za michango kwa kipindi hiki" },
  { en: "Name", sw: "Jina" },
  { en: "Type", sw: "Aina" },
  { en: "Month", sw: "Mwezi" },
  { en: "Status", sw: "Hali" },
  { en: "Accounting", sw: "Uhasibu" },
  { en: "Date", sw: "Tarehe" },
  { en: "Action", sw: "Kitendo" },
  { en: "Mchango wa Kawaida", sw: "Mchango wa Kawaida" },
  { en: "Prepare receipt", sw: "Andaa risiti" },
  { en: "Receipt #", sw: "Risiti #" },
  { en: "Import Contributions CSV", sw: "Ingiza Michango kwa CSV" },
  { en: "Upload a CSV file with columns: member_number, amount, period_month, period_year", sw: "Pakia faili la CSV lenye safu: member_number, amount, period_month, period_year" },
  { en: "Prepare contribution receipt", sw: "Andaa risiti ya mchango" },
  { en: "Cash / Bank account", sw: "Akaunti ya Fedha Taslimu / Benki" },
  { en: "Choose account", sw: "Chagua akaunti" },
  { en: "Contribution income account", sw: "Akaunti ya mapato ya michango" },
  { en: "Create & submit receipt", sw: "Unda na uwasilishe risiti" },
];

export default contributionsDict;
